export { default as BoxetteLogoDark } from "./boxette-logo-dark.svg";
export { default as BoxetteLogoLight } from "./boxette-logo-light.svg";
export { default as EasyXpressLogo } from "./easy-xpress-logo.svg";
export { default as EasyXpressLogo2 } from "./easy-xpress-logo-2.svg";
export { default as VisibilityOffIcon } from "./visibility-off.svg";
export { default as VisibilityOnIcon } from "./visibility-on.svg";
export { default as SuccessIcon } from "./success.svg";
export { default as CloseModalIcon } from "./close-modal.svg";
export { default as UserLock } from "./user-lock.svg";
export { default as Briefcase } from "./briefcase-blank.svg";
export { default as ArrowDown } from "./arrowDown.svg";
export { default as ArrowDownStroke } from "./arrow-down-stroke.svg";
export { default as MagnifyingGlass } from "./magnifying-glass.svg";
export { default as MyParcelsIcon } from "./boxes-stacked.svg";
export { default as AddressesIcon } from "./location-dot.svg";
export { default as AddLocationIcon } from "./add-location.svg";
export { default as ReferralProgramIcon } from "./user-plus.svg";
export { default as LoyalityProgramIcon } from "./stars.svg";
export { default as ServicesIcon } from "./layer-group.svg";
export { default as RatesIcon } from "./money-check-dollar.svg";
export { default as FacebookIcon } from "./facebook-f.svg";
export { default as LinkedinIcon } from "./linkedin-in.svg";
export { default as TwitterIcon } from "./twitter.svg";
export { default as QRCodeIcon } from "./qrcode.svg";
export { default as LogoutIcon } from "./logout.svg";
export { default as GeorgiaIcon } from "./georgia.svg";
export { default as RussiaIcon } from "./russia.svg";
export { default as UkraineIcon } from "./ukraine.svg";
export { default as ArrowDownIcon } from "./arrow-down.svg";
export { default as FemaleIcon } from "./user-vneck-hair-long.svg";
export { default as DoorIcon } from "./door-closed.svg";
export { default as WalletIcon } from "./wallet.svg";
export { default as MedalIcon } from "./medal.svg";
export { default as InvoiceIcon } from "./file-invoice-dollar.svg";
export { default as SmileIcon } from "./face-smile.svg";
export { default as AddIcon } from "./plus.svg";
export { default as ExpectedParcelsIcon } from "./box-taped.svg";
export { default as WarehouseIcon } from "./warehouse-full.svg";
export { default as InTransitIcon } from "./route.svg";
export { default as ArrivedIcon } from "./parachute-box.svg";
export { default as TurkeyIcon } from "./turkey.svg";
export { default as UsaIcon } from "./united-states.svg";
export { default as ShipIcon } from "./ship.svg";
export { default as PlaneIcon } from "./plane.svg";
export { default as GroundIcon } from "./truck.svg";
export { default as DotsIcon } from "./dots.svg";
export { default as DotsOtherIcon } from "./dots-other.svg";
export { default as DeleteIcon } from "./trash-can.svg";
export { default as EditIcon } from "./pen.svg";
export { default as NotificationIcon } from "./notifications_unread.svg";
export { default as AvatarFemaleIcon } from "./avatar-female.svg";
export { default as UserMenuArrow } from "./user-menu-arrow.svg";
export { default as CopyIcon } from "./copy.svg";
export { default as InfoIcon } from "./info.svg";
export { default as InfoCircleIcon } from "./info-circle.svg";
export { default as SquareChecked } from "./square-check.svg";
export { default as ChinaIcon } from "./china.svg";
export { default as SquareUnchecked } from "./square-unchecked.svg";
export { default as DeliveryServiceIcon } from "./person-carry-box.svg";
export { default as RepackageIcon } from "./box-open.svg";
export { default as BoxClosed } from "./box-closed.svg";
export { default as CameraIcon } from "./camera.svg";
export { default as ReturnIcon } from "./turn-left.svg";
export { default as OpenBoxAndSplitIcon } from "./open-box-and-split.svg";
export { default as RemoveInvoiceIcon } from "./file-slash.svg";
export { default as InsuranceIcon } from "./shield-plus.svg";
export { default as CheckParcelIcon } from "./box-circle-check.svg";
export { default as PrimaryChecked } from "./primary-checked.svg";
export { default as SecondaryChecked } from "./secondary-checked.svg";
export { default as PrimaryUnchecked } from "./primary-unchecked.svg";
export { default as OfficeIcon } from "./house-laptop.svg";
export { default as ContactIcon } from "./headset.svg";
export { default as PurchaseAssistantIcon } from "./cart-shopping-fast.svg";
export { default as BranchIcon } from "./Primary.svg";
export { default as EmailIcon } from "./envelope.svg";
export { default as PhoneIcon } from "./phone.svg";
export { default as MessengerIcon } from "./facebook-messenger.svg";
export { default as MinusIcon } from "./minus.svg";
export { default as LockIcon } from "./lock-keyhole.svg";
export { default as ArrowRightIcon } from "./arrow-right.svg";
export { default as MinusSmallIcon } from "./minus-small.svg";
export { default as PlusSmallIcon } from "./plus-small.svg";
export { default as CircleArrowDown } from "./circle-arrow-down.svg";
export { default as SearchIcon } from "./search.svg";
export { default as DollarIcon } from "./dollar-icon.svg";
export { default as DollarSquaredIcon } from "./dollar-squared.svg";
export { default as HandHoldingDollarIcon } from "./hand-holding-dollar.svg";
export { default as UploadIcon } from "./upload-icon.svg";
export { default as TrashIcon } from "./trash-icon.svg";
export { default as UpsIcon } from "./ups-icon.svg";
export { default as UserIcon } from "./user.svg";
export { default as MapPinIcon } from "./map-pin.svg";
export { default as CalculatorIcon } from "./calculator.svg";
export { default as ShippingArrowUp } from "./shipping-arrow-up.svg";
export { default as SignatureIcon } from "./pen-field.svg";
export { default as GoogleaPayIcon } from "./google-pay.svg";
export { default as BankCardIcon } from "./credit-card.svg";
export { default as ConsolidationIcon } from "./consolidation-in-ukraine.svg";
export { default as CustomsDeclarationIcon } from "./customs-declaration.svg";
export { default as LimitControlIcon } from "./limit-control.svg";
export { default as ParcelRegistrationIcon } from "./parcel-registration.svg";
export { default as PercentIcon } from "./percent.svg";
export { default as SelfPickUpIcon } from "./self-pick-up.svg";
export { default as AdditionalPackagingIcon } from "./additional-packaging.svg";
export { default as FilterFlagIcon } from "./filter-flag.svg";
export { default as FilterCategoryIcon } from "./filter-category.svg";
export { default as FilterTransportIcon } from "./filter-transport.svg";
export { default as UzbekistanIcon } from "./uzbekistan.svg";
export { default as ClickIcon } from "./click.svg";
export { default as PaymeIcon } from "./payme.svg";
export { default as AlertIcon } from "./circle-exclamation.svg";
export { default as AvatarMaleIcon } from "./avatar-male.svg";
export { default as MaleIcon } from "./male.svg";
export { default as NoDataIcon } from "./no-data.svg";
export { default as NoDataUkraineIcon } from "./no-data-uk.svg";
export { default as BuyForYouIcon } from "./local_atm.svg";
export { default as RefreshIcon } from "./refresh.svg";
export { default as TelegramIcon } from "./telegram.svg";
export { default as InstagramIcon } from "./instagram.svg";
export { default as SettingsIcon } from "./gear.svg";
export { default as BogIcon } from "./bog.svg";
export { default as GreeceIcon } from "./greece-icon.svg";
export { default as EnglandIcon } from "./england-icon.svg";
export { default as GermanyIcon } from "./germany-icon.svg";
export { default as PolandIcon } from "./poland-icon.svg";
export { default as IndiaIcon } from "./india-icon.svg";
export { default as SpainIcon } from "./spain-icon.svg";
export { default as Info2Icon } from "./info2.svg";
export { default as CustomsDutyIcon } from "./customs-duty.svg";
export { default as CouponIcon } from "./coupon.svg";
export { default as CardIcon } from "./card.svg";
